export default __webpack_public_path__ + "static/media/02c_fold-9.ee2b3ad6.mp4";